import { useEffect, useRef, useState } from "react";
import GeetGovindServices from "../Services/GeetGovind";
import DefaultBook from "../Images/defaultBook.png";
import ListPagination from "../Components/ListPagination";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "../Styles/Books.css";
import i18n from "../i18n";
import { useTranslation } from "react-i18next";
import Reset from "../Images/reset.png";
import $ from "jquery";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Breadcrumbs } from "./E-BooksComponent"
import Loader from "./Loader";
import { FilterIcon, SortIcon } from "./Icon";

const GeetgovindPage = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { lang: urlLang } = useParams();
  const [Monthly, setMonthly] = useState<any[] | undefined>(undefined);

  const [refresh, setRefresh] = useState(false);
  const [SortValue, setSortValue] = useState("0");
  const [Language, setLanguage] = useState<any[]>([]);
  const navLanguage =
    ((location.state as { magazineLangauge?: string } | null)?.magazineLangauge ?? urlLang ?? "").trim();
  const [LanguageId, setLanguageId] = useState<string>("");
  const lastResolvedNav = useRef<string | null>(null);

  const [loading, setLoading] = useState(true);

  const [pagination, setPagination] = useState({
    pageNo: 1,
    recordsPerPage: 12,
    totalRecords: 0,
  });

  function ResetData() {
    setSortValue("0");
    setLanguageId("");
    lastResolvedNav.current = null;
    setPagination({
      ...pagination,
      pageNo: 1,
    });
    setLoading(true);
    navigate("/magazines/geetgovind", { replace: true });
    setRefresh(true);
  }

  useEffect(() => {
    lastResolvedNav.current = null;
  }, [navLanguage]);

  useEffect(() => {
    GeetGovindServices.getGeetFilters("monthlymagazine").then((res) => {
      if (res?.status) {
        setLanguage(res?.result?.languages ?? []);
      }
    });
  }, [i18n.language]);

  useEffect(() => {
    if (!navLanguage || Language.length === 0) return;
    if (lastResolvedNav.current === navLanguage) return;

    const exact = Language.find(
      (lang: any) => String(lang.id).toLowerCase() === navLanguage.toLowerCase()
    );
    const byName = Language.find(
      (lang: any) => String(lang.name).toLowerCase() === navLanguage.toLowerCase()
    );
    const matched = exact || byName;
    lastResolvedNav.current = navLanguage;
    if (matched) {
      setLanguageId(matched.id);
    }
  }, [navLanguage, Language]);

  useEffect(() => {
    $(".LanguageList > ul > li > div").removeClass("listActive");
    if (LanguageId) {
      try {
        const escapedId = LanguageId.replace(/([!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1');
        $("#lan-" + escapedId).addClass("listActive");
      } catch (e) {}
    }
  }, [LanguageId, Language]);

  useEffect(() => {
    setRefresh(false);
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await GeetGovindServices.getMonthlyMagazine(
          "",
          pagination.pageNo === 0
            ? 0
            : pagination.recordsPerPage * pagination.pageNo - 12,
          pagination.recordsPerPage,
          "",
          false,
          SortValue,
          "",
          LanguageId,
          window.location.pathname === "/magazines/geetgovind/special" ? true : false,
          ""
        );
        const result = await response;
        setMonthly(result.result?.items);
        setPagination({
          ...pagination,
          totalRecords: result.result?.totalRecords,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [refresh, i18n.language, SortValue, LanguageId, pagination.pageNo]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

const mainTitle = `<h1 style="margin:0;font-size:24px">
  ${t("MonthlyMagazine_tr")}
</h1>`;
  
    const style:any=()=>{
        return(
          <>
            <h1 style={{fontWeight:700,fontSize:"36px"}}>{t("MonthlyMagazine_tr")}</h1>
              <div style={{ marginLeft: "297px", height: "65px", border: "0.1px solid #facc6f",width:"1px",marginTop:"-75px" }}></div>
          </>
        )
    }
    
  return (
    <>
    
    {/* <h1>{t("MonthlyMagazine_tr")}</h1> */}
          {/* <h2 
      style={{
        textAlign: "center",
        // color: "#2f2a24",
        color:"rgb(228, 121, 7)",
        textShadow: "0px 0px 4px rgba(255,255,255,0.9)",
        fontWeight: 600,
        marginLeft:"150px"
      }}
      >
        {t("Geet_Govind_title_tr")}
      </h2>

<div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "8px",
    marginLeft: "140px",
  }}
>
  <div style={{ width: "180px", height: "1px", background: "#E5B15A" }} />

  <svg
    width="26"
    height="18"
    viewBox="0 0 26 18"
    style={{ margin: "0 12px" }}
  >
    <rect x="1" y="7" width="2" height="4" rx="1" fill="#E5B15A" />
    <rect x="5" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
    <rect x="9" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
    <rect x="13" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
    <rect x="17" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
    <rect x="21" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
  </svg>

  <div style={{ width: "180px", height: "1px", background: "#E5B15A" }} />
</div>

  <p
  style={{
    fontSize: 17,
    position: "absolute",
    left: "37%",
    color: "#4a4036",
    textShadow: "0px 0px 4px rgba(255,255,255,0.8)",

    width: "854px",      // 900px tak width
    maxWidth: "100%",    // screen chhoti ho to overflow na ho

    whiteSpace: "normal",
    overflowWrap: "break-word",
  }}
>
  {t("Geet_Govind_description_tr")}
</p>


    <div>     
      <Breadcrumbs
        // mainsubBreadCrumb={mainTitle}
        mainsubBreadCrumb={style()}
        subBreadCrumb={t("Home_tr")}
        navigatemainsubBreadCrumb={() => {
          navigate(`/`);
        }}
        subBreadCrumbTwo={t("magazine_tr")}
        navigatesubBreadCrumb={() => {
          navigate(`/magazines`);
        }}
        subBreadCrumbThree={t("MonthlyMagazine_tr")}
        />  
    </div>    */}

<div style={{ backgroundColor: "rgb(255, 237, 188)", padding: "0px 0px 0px 0px",marginTop:"-60px" }}>
      <div style={{ width: "100%", maxWidth: "1200px", margin: "0 auto", padding: "0 10px",backgroundColor:"rgb(255, 237, 188)" }}>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: "20px",
                flexWrap: "wrap",
                padding: "28px 0 16px",
              }}
            >
              <div style={{ flex: "0 1 260px", minWidth: "220px" }}>
                <div style={{ padding: "8px 0" }}>
                  <h1 style={{ color: "#cf2c24", fontSize: "40px", margin: 0, fontWeight: 700,marginTop:"70px", textShadow: "0px 0px 4px rgba(255,255,255,0.9)" }}>
                    {t("MonthlyMagazine_tr")}
                  </h1>
                  <div style={{ marginTop: "10px", fontSize: 19,fontWeight:600,color:"rgb(45, 42, 41)" }}>
                    <Link to="/" style={{ marginRight: "", color: "#2d2a29" }}>{t("Home_tr")}</Link>
                    <span style={{ margin: "0 6px" }}>/</span>
                    <Link to="/magazines" style={{ marginRight: "", color: "#2d2a29" }}>{t("magazine_tr")}</Link>
                    <span style={{ margin: "0 6px" }}>/</span>
                    <span>{t("MonthlyMagazine_tr")}</span>
                  </div>
                </div>
              </div>

              <div
                style={{
                  width: "1px",
                  minHeight: "100px",
                  background: "#facc6f",
                  marginTop: "65px",
                }}
              />

              <div style={{ flex: "1 1 520px", minWidth: "300px" }}>
                <h2
                  style={{
                    textAlign: "center",
                    color: "rgb(228, 121, 7)",
                    textShadow: "0px 0px 4px rgba(255,255,255,0.9)",
                    fontWeight: 600,
                    margin: 0,
                    paddingTop:"30px",
                    // marginb:"-10px",
                  }}
                >
                  {t("Geet_Govind_title_tr")}
                </h2>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "8px",
                    gap: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ width: "250px", height: "1px", background: "#E5B15A" }} />
                  <svg
                    width="26"
                    height="18"
                    viewBox="0 0 26 18"
                    style={{ margin: "0 12px" }}
                  >
                    <rect x="1" y="7" width="2" height="4" rx="1" fill="#E5B15A" />
                    <rect x="5" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                    <rect x="9" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
                    <rect x="13" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                    <rect x="17" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
                    <rect x="21" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                  </svg>
                  <div style={{ width: "250px", height: "1px", background: "#E5B15A" }} />
                </div>

                <p
                  style={{
                    fontSize: 17,
                    color: "#4a4036",
                    textShadow: "0px 0px 4px rgba(255,255,255,0.8)",
                    // margin: "25px 0 -10px",
                    margin:"18px 0px 0px 0px",
                    width: "100%",
                    lineHeight: 1.75,
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                    textAlign: "justify",
                  }}
                >
                  {t("Geet_Govind_description_tr")}
                </p>
              </div>
            </div>
      </div>
  </div>

  

      <div
        className="fontfamily"
        style={{
          userSelect: "none",
          backgroundColor: "rgb(255, 246, 225)",
          padding: "1px 0 3% 0",
        }}
      >  
        <div className="containers">
        
          <div
            className="gst-page-content pagecontentbackground"
            style={{ backgroundColor: "#FFF6E1" }}
          >
            <div className="row">
              <div className="col-lg-3">
                <div
                  style={{
                    display: "block",
                    padding: "16px",
                    borderRadius: "4px",
                    background: "#FFFAF0",
                    boxShadow: "0 0 7px 1px #f5deb1",
                    fontFamily: "ChanakyaUni",
                    height: "100%",
                  }}
                >
                  
                  <div
                    className="cardbackground"
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                <FilterIcon /><span className="boxheadtitle" style={{ color: "rgb(228, 121, 7)" }}>{t("Filter_tr")}</span>
                    {(LanguageId !== "" || pagination.pageNo > 1) && (
                      <img
                        alt="reset"
                        src={Reset}
                        className="resetimg"
                        onClick={() => {
                          ResetData();
                        }}
                      />
                    )}
                  </div>
                  <div>
                    {/* Kalyan_kalpataru_number_tr */}
                    <Accordion defaultExpanded elevation={0}>
                      <AccordionSummary
                        expandIcon={<ExpandMore />}
                        style={{
                          height: 0,
                          background: "#FFFAF0",
                          minHeight: "25px"
                        }}
                      >
                        <h2 className="filtertitle">{t("Languages_tr")}</h2>
                      </AccordionSummary>


                      <AccordionDetails
                        style={{
                          display: "block",
                          background: "#FFFAF0",
                          // padding: 0,
                        }}
                      >
                        {Language && Language.length > 0
                          ? Language?.map((Language: any) => (
                            <div
                              key={`c-${Language.id}`}
                              className="LanguageList"
                              onClick={() => {
                                setLanguageId(Language.id);
                                setPagination({
                                  ...pagination,
                                  pageNo: 1,
                                });
                                setRefresh(true);
                              }}
                            >
                              <ul style={{ margin: 0 }}>
                                <li>
                                  <div
                                    style={{
                                      fontSize: "21px",
                                      cursor: "pointer",
                                      fontWeight: 400,
                                      color: "#545454",
                                      fontFamily: "ChanakyaUni",
                                    }}
                                    id={`lan-${Language.id}`}
                                  >
                                    <h2
                                       style={{
                                      fontSize: "21px",
                                      cursor: "pointer",
                                      fontWeight: 400,
                                      color: "#545454",
                                      fontFamily: "ChanakyaUni",
                                    }}
                                    >
                                      {Language.name}
                                      
                                      </h2>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          ))
                          : ""}
                      </AccordionDetails>


                    </Accordion>
                  </div>
                </div>
              </div>
              <div className="col-lg-9">
                <div
                  className="detailbg"
                  style={{
                    display: "block",
                    padding: "16px",
                    borderRadius: "4px",
                    background: "#FFFAF0",
                    boxShadow: "0 0 7px 1px #f5deb1",
                    height: "100%",
                    fontFamily: "ChanakyaUni",
                  }}
                >
                  <div className="sidebarmargin">
                    <div
                      className="align-items-center row"
                      style={{ margin: "-10px -10px 25px -10px" }}
                    >
                      <div className="col-6">
                        <div className="filter1" style={{ marginTop: "10px" }}>
                     <span style={{ color: "rgb(228, 121, 7)", fontFamily: 'chanakyaUni', fontSize: "22px" }}>
                            {t("Total_Records_tr")} : {pagination.totalRecords}
                          </span>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="filter1" style={{ textAlign: "right" }}>
                                <SortIcon />  <span style={{ color: "rgb(228, 121, 7)", fontFamily: "chanakyaUni", fontSize: "22px" }}>{t("Sort_tr")}</span>
                          <select
                            style={{ backgroundColor: "#FFF2D5" }}
                            value={SortValue}
                            onChange={(e) => {
                              setSortValue(e.target.value);
                            }}
                          >
                            <option value="3">{t("Popular_tr")}</option>
                            <option value="2">{t("Latest_tr")}</option>
                            <option value="0">{t("General_tr")}</option>
                            <option value="1">{t("Title_tr")}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    {Monthly && Monthly.length > 0 ? (
                      <div>
                        <div className="row">
                          {Monthly.map((Month) => (
                            <div key={Month?.id} className="col-lg-3 col-sm-6 col-md-6">
                              <div
                                className="sidebarmargin"
                                onClick={() => {
                                  navigate(`/magazines/geetgovind/` + (Month.slug || Month.id), {
                                    state: {
                                      MonthId: Month.id,
                                      bookName: Month?.name,
                                      slug: Month.slug || Month.id,
                                      label: Month.label
                                    }
                                  })
                                }}
                              >
                                <div className="bookBox">
                                  <a>
                                    <img
                                      style={{
                                        cursor: "pointer",
                                        borderRadius: 0,
                                      }}
                                      src={Month.monthlyMagazineThumbPath}
                                      onError={(e) => {
                                        e.currentTarget.src = DefaultBook;
                                      }}
                                      alt={Month.name}
                                      title={Month.name}
                                      width="117"
                                      height="165"
                                    />
                                   <p style={{ cursor: "pointer" }}>
                                      {Month.name}
                                    </p>
                                  </a>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="col-12" style={{ marginTop: "30px", display: pagination.totalRecords <= 12 ? "none" : "block" }}>
                          <ListPagination
                            totalRecords={pagination.totalRecords}
                            recordsPerPage={pagination.recordsPerPage}
                            currentPage={pagination.pageNo}
                            onClick={(p) => {
                              setPagination({
                                ...pagination,
                                pageNo: p,
                              });
                              setRefresh(true);
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="ebooks-category resultnotfound">
                        {loading && <Loader loading={loading} />}
                        {t("result_not_found_tr")}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default GeetgovindPage;
